@if (hasDataset() && ranges(); as range) {
    <sirius-container>
        <section class="robot-selector-layout">
            <div class="robot-selector-controls sir-text-context-on-dark">
                @if (heading()) {
                    <h2 class="robot-selector-title sir-text-style-title-l-default">{{ heading() }}</h2>
                }
                @if (subheading()) {
                    <p class="robot-selector-introduction sir-text-style-paragraph-m-default">{{ subheading() }}</p>
                }

                <div class="robot-selector-fields">
                    @if (hasGuidedRoute()) {
                        <fieldset
                            #guidedGroup
                            class="robot-selector-group"
                            [class.is-reset]="notice()?.resetGroup === 'guided'">
                            <legend class="robot-selector-legend sir-text-style-system-s-bold">{{ guidedLegend() }}</legend>

                            <robot-selector-taxonomy-select
                                [label]="industryLabel()"
                                [optionalSuffix]="optionalSuffix()"
                                [noSelectionLabel]="noSelectionLabel()"
                                [options]="taxonomyOptions().industries"
                                [value]="requirement().industry"
                                (valueChange)="onIndustryChange($event)" />

                            <robot-selector-taxonomy-select
                                [label]="applicationLabel()"
                                [optionalSuffix]="optionalSuffix()"
                                [noSelectionLabel]="noSelectionLabel()"
                                [options]="taxonomyOptions().applications"
                                [value]="requirement().application"
                                (valueChange)="onApplicationChange($event)" />
                        </fieldset>
                    }

                    @if (notice(); as current) {
                        <robot-selector-route-notice
                            [message]="current.message"
                            [undoLabel]="undoLabel()"
                            (undo)="undo()" />
                    }

                    <fieldset
                        #specsGroup
                        class="robot-selector-group"
                        [class.is-inactive]="route() === 'guided'"
                        [class.is-reset]="notice()?.resetGroup === 'specs'">
                        @if (hasGuidedRoute()) {
                            <legend class="robot-selector-legend sir-text-style-system-s-bold">{{ specsLegend() }}</legend>
                        }

                        <robot-selector-requirement-slider
                            [label]="payloadLabel()"
                            [value]="requirement().payloadKg"
                            [min]="range.payloadKg.min"
                            [max]="range.payloadKg.max"
                            [step]="range.payloadKg.step"
                            unit="kilogram"
                            [locale]="locale()"
                            (settled)="onPayloadSettled($event)" />

                        <robot-selector-requirement-slider
                            [label]="reachLabel()"
                            [value]="requirement().reachMm"
                            [min]="range.reachMm.min"
                            [max]="range.reachMm.max"
                            [step]="range.reachMm.step"
                            unit="millimeter"
                            [locale]="locale()"
                            (settled)="onReachSettled($event)" />
                    </fieldset>
                </div>

                <button siriusButton class="robot-selector-reset" buttonType="linkstyle" type="button" (click)="reset()">
                    {{ resetLabel() }}
                </button>
            </div>

            <div class="robot-selector-results">
                <div class="robot-selector-results-header">
                    @if (resultsHeading()) {
                        <h2 class="robot-selector-results-title sir-text-style-title-l-default">
                            {{ resultsHeading() }}
                        </h2>
                    }

                    @if (canExpand()) {
                        <button
                            siriusButton
                            class="robot-selector-results-toggle"
                            buttonType="secondary"
                            size="medium"
                            type="button"
                            [attr.aria-expanded]="isExpanded()"
                            (click)="toggleExpanded()">
                            {{ toggleLabel() }}
                        </button>
                    }
                </div>

                <p class="robot-selector-results-summary sir-text-style-paragraph-m-default">
                    {{ resultsSubheading() }}
                </p>

                <div class="robot-selector-results-content">
                    @if (isNoMatch()) {
                        <robot-selector-alternatives-panel
                            [alternatives]="alternatives()"
                            [viewProductLabel]="viewProductLabel()"
                            [relaxRequirementLabel]="relaxRequirementLabel()"
                            [statusTemplates]="statusTemplates()"
                            [requirement]="requirement()"
                            (alternativeSelected)="onAlternativeSelected($event)" />
                    } @else {
                        <robot-selector-result-list
                            [results]="results()"
                            [bestMatchLabel]="bestMatchLabel()"
                            [viewProductLabel]="viewProductLabel()"
                            [isExpanded]="isExpanded()"
                            [markBestMatch]="route() !== 'featured'" />
                    }
                </div>

                <footer class="robot-selector-footer">
                    @if (disclaimer()) {
                        <p class="robot-selector-disclaimer sir-text-style-paragraph-s-default">{{ disclaimer() }}</p>
                    }
                    @if (expertRoute(); as expert) {
                        <a siriusButton buttonType="primary" size="medium" [siriusLink]="expert.link">
                            {{ expert.text }}
                        </a>
                    }
                </footer>
            </div>

            <p class="robot-selector-announcement" aria-live="polite" role="status">{{ announcement() }}</p>
        </section>
    </sirius-container>
}
